import { Maybe } from '../../../__generated__/globalTypes'

import { AddressFragment, isAddressFragment } from './AddressFragment'

import recipientFragmentRawString from '../RecipientFragment.graphql'

export const recipientFragmentString = recipientFragmentRawString

export type RecipientFragment = {
  __typename: 'Recipient'
  id: string
  address: Maybe<
    AddressFragment & {
      userVerified: boolean
      errorMessages: string[]
    }
  >
  gift: Maybe<{
    name: string
    defaultImageUrl: string
  }>
  card: Maybe<{
    frontPreviewUrl: string
    id: string
    sendableCard: Maybe<{
      title: string
    }>
  }>
}

export const isRecipientFragment = (
  fragment: any,
): fragment is RecipientFragment =>
  fragment &&
  fragment.__typename === 'Recipient' &&
  typeof fragment.id === 'string' &&
  (fragment.address === null ||
    ((isAddressFragment(fragment.address) as boolean) &&
      typeof fragment.address.userVerified === 'boolean' &&
      Array.isArray(fragment.address.errorMessages) &&
      fragment.address.errorMessages
        .slice(0, 5)
        .reduce(
          (accum: any, next: any) => accum && typeof next === 'string',
          true,
        ))) &&
  (fragment.gift === null ||
    (fragment.gift &&
      typeof fragment.gift.name === 'string' &&
      typeof fragment.gift.defaultImageUrl === 'string')) &&
  (fragment.card === null ||
    (fragment.card &&
      typeof fragment.card.frontPreviewUrl === 'string' &&
      typeof fragment.card.id === 'string' &&
      (fragment.card.sendableCard === null ||
        (fragment.card.sendableCard &&
          typeof fragment.card.sendableCard.title === 'string'))))
